import classNames from 'classnames';
import { isValid, parseISO } from 'date-fns';
import { FunctionComponent } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { NoValue } from '../../app/sharedComponents/NoValue';
import { DateTime } from '../../app/sharedComponents/table/BaseTableComponents';
import { isXmlString, XmlResult } from './XmlResult';

const isValidTimestamp = (value: unknown): value is string => typeof value === 'string' && isValid(parseISO(value));

export const DisplayResult: FunctionComponent<{ value: unknown }> = ({ value }) => {
    if (value === undefined || value === null) {
        return <NoValue />;
    }
    if (typeof value === 'number') {
        return <FormattedNumber value={value} />;
    }
    if (typeof value === 'boolean') {
        return (
            <span className={classNames('badge', { 'badge-success': value, 'badge-warning': !value })}>
                <FormattedMessage id={value ? 'outboundOrderBook.common.yes' : 'outboundOrderBook.common.no'} />
            </span>
        );
    }
    if (isValidTimestamp(value)) {
        return (
            <>
                <DateTime dateTime={parseISO(value)} timeZone="Etc/UTC" />
                <span className="text-thin text-color-darker"> UTC</span>
            </>
        );
    }
    if (typeof value === 'string' && value !== '') {
        if (isXmlString(value)) {
            return <XmlResult rawXmlString={value} />;
        }
        return value;
    }
    return <span className="json-code bg-lightest rounded">{JSON.stringify(value)}</span>;
};
